import { useAuth } from "@/context/AuthContext";
import PageHeader from "@/components/PageHeader";
import RecordsSection from "@/components/RecordsSection";
import { chainColumns, chainFields, chainDefault } from "@/lib/entities";
import { Link2 } from "lucide-react";

export default function ChainGangs() {
  const { user } = useAuth();
  const officer = user ? `${user.name}${user.dienstnummer ? ` (${user.dienstnummer})` : ""}` : "";

  return (
    <div>
      <PageHeader
        eyebrow="SADCR · Vollzug"
        title="Chain-Gangs"
        description="Dokumentation der Chain-Gang-Tätigkeiten, Anfragen und verkürzten Zeiten."
        icon={Link2}
      />
      <div className="p-8">
        <RecordsSection
          endpoint="/chaingangs"
          columns={chainColumns}
          fields={chainFields}
          makeDefault={chainDefault(officer)}
          createLabel="Chain-Gang eintragen"
          emptyLabel="Keine Chain-Gang-Einträge erfasst"
          testidPrefix="chain"
        />
      </div>
    </div>
  );
}
